/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';
import type { MemberContactPhone } from './MemberContactPhone';
import {
    MemberContactPhoneFromJSON,
    MemberContactPhoneFromJSONTyped,
    MemberContactPhoneToJSON,
} from './MemberContactPhone';

/**
 * 
 * @export
 * @interface GetAccountMembershipContactPhones200Response
 */
export interface GetAccountMembershipContactPhones200Response {
    /**
     * 
     * @type {Array<MemberContactPhone>}
     * @memberof GetAccountMembershipContactPhones200Response
     */
    data: Array<MemberContactPhone>;
    /**
     * 
     * @type {Metadata}
     * @memberof GetAccountMembershipContactPhones200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the GetAccountMembershipContactPhones200Response interface.
 */
export function instanceOfGetAccountMembershipContactPhones200Response(value: object): value is GetAccountMembershipContactPhones200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function GetAccountMembershipContactPhones200ResponseFromJSON(json: any): GetAccountMembershipContactPhones200Response {
    return GetAccountMembershipContactPhones200ResponseFromJSONTyped(json, false);
}

export function GetAccountMembershipContactPhones200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountMembershipContactPhones200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberContactPhoneFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function GetAccountMembershipContactPhones200ResponseToJSON(value?: GetAccountMembershipContactPhones200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberContactPhoneToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

